export default {
    "downloadReport_loading": "Cargando...",
    "downloadReport_success": "Descarga completada",
    "downloadReport_downloading": "Descargando...",
    "downloadReport_manualClose_title": "✅ Descarga completada",
    "downloadReport_manualClose_message": "Puede cerrar esta ventana de forma segura.",
    "downloadReport_manualClose_button": "Cerrar ventana",
    "downloadReport_error": "Error en la descarga",
    "downloadReport_error_message": "Error en la descarga. Por favor, intente nuevamente.",
    "downloadReport_expired_link": "Enlace expirado",
    "downloadReport_generic_error": "Error del sistema"
}
